import React from 'react';
import ConstructionPlanningInterface from './components/ConstructionPlanningInterface';
import './App.css';

function App() {
  return (
    <div className="App">
      <ConstructionPlanningInterface />
    </div>
  );
}

export default App;
